import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaHome, FaTv, FaClipboardList, FaFileAlt } from "react-icons/fa";
import "./mobileBottomNav.css";

const NAV_ITEMS = [
  { key: "home", label: "Home", icon: <FaHome />, route: "/" },
  { key: "inplay", label: "In-Play", icon: <FaTv />, route: "/live-games" },
  { key: "markets", label: "My Markets", icon: <FaClipboardList />, route: "/report/unsetteled-bet" },
  { key: "passbook", label: "Passbook", icon: <FaFileAlt />, route: "/account" },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isCasinoGame = location.pathname === "/diamond-casino/play";

  const isActive = (route) => {
    if (route === "/") return location.pathname === "/";
    return location.pathname.startsWith(route);
  };

  if (isCasinoGame) return null;

  return (
    <nav className="mobile-bottom-nav" aria-label="Bottom navigation">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.key}
          className={`mobile-bottom-nav__item ${isActive(item.route) ? "mobile-bottom-nav__item--active" : ""}`}
          onClick={() => navigate(item.route)}
          type="button"
          aria-label={item.label}
        >
          <span className="mobile-bottom-nav__icon">{item.icon}</span>
          <span className="mobile-bottom-nav__label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
